<script>

import 'prismjs';
import 'prismjs/components/prism-json';
import Prism from 'vue-prism-component';
import api from '@/api';
import dataViewerFullscreen from './data-viewer-fullscreen.vue'

export default {
    name: 'detail-item',
    props: ['compact', 'item', 'title', 'detailKey'],
    data() {
        return {
            loading: false,
            fullVisible: false,
            fullString: JSON.stringify({}),
        };
    },
    created() {
        this.checkOverflow = () => {
            const el = this.$refs.codebox;

            if (!el) {
                return;
            }

            const action = el.scrollWidth > el.offsetWidth + 2
                || el.scrollHeight > el.offsetHeight + 2
                ? 'add'
                : 'remove';

            this.$el.classList[action]('overflow');
        };
        window.addEventListener('resize', this.checkOverflow);
        ['item', 'compact'].forEach(e => this.$watch(e, this.checkOverflow));
        this.$watch(() => this.$route, this.checkOverflow);
    },
    mounted() {
        this.checkOverflow();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkOverflow);
    },
    methods: {
        handleOk() {
            this.fullVisible = false;
        },
        viewFullScreen() {
            // 请求接口
            this.getEscapeValue();
        },
        async getEscapeValue() {
            const regex = /(?<=\$\().+?(?=\))/g;
            const allEscapes = this.item.match(regex) || [];
            this.loading = true;
            this.fullString = this.item;
            // eslint-disable-next-line no-restricted-syntax
            for (const reference of allEscapes) {
                // eslint-disable-next-line no-await-in-loop
                const res = await api.getEscapeValue({ reference });
                if (res.status === 200 && res.data?.response) {
                    const { response } = res.data;
                    let repalceStr;
                    if (typeof response === 'object') {
                        // eslint-disable-next-line no-new-object
                        repalceStr = JSON.stringify(new Object(response), null, 2);
                    } else {
                        repalceStr = response;
                    }
                    this.fullString = this.fullString.replaceAll(`$(${reference})`, repalceStr);
                } else if (res.status === 200) {
                    this.fullString = this.fullString.replace(`$(${reference})`, '')
                } else {
                    this.$message.error('查询变量失败！');
                }
            }
            this.loading = false;
            this.fullVisible = true;
        },
    },
    components: {
        prism: Prism,
        'data-viewer-full': dataViewerFullscreen,
    },
};
</script>

<template>
    <div class="detail-item">
        <span v-if="detailKey && detailKey === 'script'">
            <a-spin :spinning="loading">
                <a
                    href="#"
                    class="view-full-screen"
                    @click.stop.prevent="viewFullScreen"
                ></a>
                <prism language="js" ref="codebox">{{ item }}</prism>
                <a-modal :visible="fullVisible"  :title="title"  dialogClass="full-json-modal"
                         @ok="handleOk"  @cancel="handleOk" width="100%" centered>
                    <data-viewer-full :code="fullString" :title="title" @close="handleOk"></data-viewer-full>
                </a-modal>
            </a-spin>

        </span>
        <span v-else>{{item}}</span>
    </div>
</template>

<style lang="stylus">
@require "../styles/definitions.styl"

.detail-item
  position relative
//   &:not(.overflow) a.view-full-screen
//     display none
  a.view-full-screen
    position absolute
    top 1px
    right 0
    margin-right 10px
    width 28px
    height calc(100% - 6px)
    max-height 28px
    // background-color white
    // border 1px solid uber-black-80
    // border-radius 4px
    background-color alpha(uber-white-20, 70%)
    display flex
    justify-content center
    align-items center
    icon('\ea90')
    &::before
      margin 0
      font-size 18px

[data-modal="data-viewer-fullscreen"]
  .v--modal-box.v--modal
    max-width calc(100vw - 20px)
    max-height calc(100vh - 20px)
  div.data-viewer-fullscreen
    flex-exactly-to-parent(column)
    pre
      flex 1
      overflow auto
    header
      padding-right 30px
      h3
        one-liner-ellipsis()
</style>
<style lang="scss">
    .data-viewer-fullscreen {
        .head {
            display: flex;
            align-items: center;
            .icon-copy {
                display: inline-block;
            }
        }
        .json-content {
            max-height: calc(100vh  - 172px);
        }
    }
</style>
